export default "__VITE_ASSET__C$1XUNiT__"